export type { CreateUIAnalyticsEvent } from './types';

// Analytics event classes
/**
 * @deprecated Volt migration shim. Import from the explicit subpath instead.
 * Retained only while consumers migrate off the root barrel.
 */
export { default as AnalyticsEvent } from './events/AnalyticsEvent';
/**
 * @deprecated Volt migration shim. Import from the explicit subpath instead.
 * Retained only while consumers migrate off the root barrel.
 */
export { isAnalyticsEvent } from './events/isAnalyticsEvent';
export type { AnalyticsEventPayload, AnalyticsEventProps } from './events/AnalyticsEvent';
/**
 * @deprecated Volt migration shim. Import from the explicit subpath instead.
 * Retained only while consumers migrate off the root barrel.
 */
export { default as UIAnalyticsEvent } from './events/UIAnalyticsEvent';
/**
 * @deprecated Volt migration shim. Import from the explicit subpath instead.
 * Retained only while consumers migrate off the root barrel.
 */
export { isUIAnalyticsEvent } from './events/isUIAnalyticsEvent';
export type { UIAnalyticsEventProps, UIAnalyticsEventHandler } from './events/UIAnalyticsEvent';

// AnalyticsListener component
/**
 * @deprecated Volt migration shim. Import from the explicit subpath instead.
 * Retained only while consumers migrate off the root barrel.
 */
export { default as AnalyticsListener } from './components/AnalyticsListener/index';

// AnalyticsContext component and HOC
/**
 * @deprecated Volt migration shim. Import from the explicit subpath instead.
 * Retained only while consumers migrate off the root barrel.
 */
export { default as AnalyticsContext } from './components/AnalyticsContext/index';
/**
 * @deprecated Volt migration shim. Import from the explicit subpath instead.
 * Retained only while consumers migrate off the root barrel.
 */
export { default as withAnalyticsContext } from './hocs/withAnalyticsContext';
export type { WithContextProps } from './hocs/withAnalyticsContext';

// AnalyticsErrorBoundary component
/**
 * @deprecated Volt migration shim. Import from the explicit subpath instead.
 * Retained only while consumers migrate off the root barrel.
 */
export { default as AnalyticsErrorBoundary } from './components/AnalyticsErrorBoundary';
export type { AnalyticsErrorBoundaryProps } from './components/AnalyticsErrorBoundary';

// createAnalyticsEvent HOC
/**
 * @deprecated Volt migration shim. Import from the explicit subpath instead.
 * Retained only while consumers migrate off the root barrel.
 */
export { default as withAnalyticsEvents } from './hocs/withAnalyticsEvents';
export type { WithAnalyticsEventsProps } from './hocs/withAnalyticsEvents';

// React context
/**
 * @deprecated Volt migration shim. Import from the explicit subpath instead.
 * Retained only while consumers migrate off the root barrel.
 */
export { default as AnalyticsReactContext } from './components/AnalyticsReactContext';
export type { AnalyticsReactContextInterface } from './components/AnalyticsReactContext';

// Hook for creating and firing analytics events
/**
 * @deprecated Volt migration shim. Import from the explicit subpath instead.
 * Retained only while consumers migrate off the root barrel.
 */
export { useAnalyticsEvents } from './hooks/useAnalyticsEvents';
export type { UseAnalyticsEventsHook } from './hooks/useAnalyticsEvents';

/**
 * @deprecated Volt migration shim. Import from the explicit subpath instead.
 * Retained only while consumers migrate off the root barrel.
 */
export { useCallbackWithAnalytics } from './hooks/useCallbackWithAnalytics';
export type { UseCallbackWithAnalyticsHook } from './hooks/useCallbackWithAnalytics';
/**
 * @deprecated Volt migration shim. Import from the explicit subpath instead.
 * Retained only while consumers migrate off the root barrel.
 */
export { usePlatformLeafEventHandler } from './hooks/usePlatformLeafEventHandler';
export type {
	UsePlatformLeafEventHandlerHookArgs,
	UsePlatformLeafEventHandlerHook,
} from './hooks/usePlatformLeafEventHandler';

/**
 * @deprecated Volt migration shim. Import from the explicit subpath instead.
 * Retained only while consumers migrate off the root barrel.
 */
export { usePlatformLeafSyntheticEventHandler } from './hooks/usePlatformLeafSyntheticEventHandler';
export type {
	UsePlatformLeafSyntheticEventHandlerHookArgs,
	UsePlatformLeafSyntheticEventHandlerHook,
} from './hooks/usePlatformLeafSyntheticEventHandler';

// Helper functions
/**
 * @deprecated Volt migration shim. Import from the explicit subpath instead.
 * Retained only while consumers migrate off the root barrel.
 */
export { default as createAndFireEvent } from './utils/createAndFireEvent';
/**
 * @deprecated Volt migration shim. Import from the explicit subpath instead.
 * Retained only while consumers migrate off the root barrel.
 */
export { default as cleanProps } from './utils/cleanProps';

// Moved from deprecated @atlaskit/analytics
/**
 * @deprecated Volt migration shim. Import from the explicit subpath instead.
 * Retained only while consumers migrate off the root barrel.
 */
export { AnalyticsDecorator } from './components/AnalyticsDecorator/AnalyticsDecorator';
/**
 * @deprecated Volt migration shim. Import from the explicit subpath instead.
 * Retained only while consumers migrate off the root barrel.
 */
export { default as AnalyticsDelegate } from './components/AnalyticsDelegate';
/**
 * @deprecated Volt migration shim. Import from the explicit subpath instead.
 * Retained only while consumers migrate off the root barrel.
 */
export { default as withAnalytics } from './utils/withAnalytics';
